import { RawLabelType, getTranslatableField } from '@sentecacommerce-theme/lib'

export type LabelType = {
  _id?: string
  version?: number
  key: string
  name: string
  description: string
  location: object
  isIcon: boolean
  appearance: object
  icon?: string
  color?: string
  backgroundColor?: string
}
enum LabelDTOLocationEnum {
  TopLeft = 'top-left',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
}

export const mapLabels = ({
  labels,
  isListing = false,
  discountedPrice,
  isInAction = false,
}: {
  labels: RawLabelType[]
  isListing?: boolean
  discountedPrice?: boolean
  isInAction?: boolean
}): LabelType[] => {
  const positionCounter = {
    'top-left': 0,
    'top-right': 0,
    'bottom-left': 0,
    'bottom-right': discountedPrice ? 1 : 0,
  }
  const mappedLabels = labels.map((el, i) => {
    return {
      _id: el._id,
      version: el.version,
      key: el.key,
      name: getTranslatableField(el.name), // getTranslatableField
      description: getTranslatableField(el.description), // getTranslatableField
      location: getPosition(
        el.location,
        positionCounter,
        isListing,
        isInAction
      ),
      isIcon: Boolean(el.icon),
      icon: el.icon,
      appearance: getAppearance(el),
      LabelDTOLocationEnum,
    }
  })
  return mappedLabels
}

const getPosition = (
  location: LabelDTOLocationEnum,
  positionCounter: {
    'top-left': number
    'top-right': number
    'bottom-left': number
    'bottom-right': number
  },
  isListing: boolean,
  isInAction: boolean
) => {
  let res = {}
  const shift = isListing
    ? positionCounter[location] * 3 + 6.5
    : positionCounter[location] * 3.5 + 4.5

  switch (location) {
    case LabelDTOLocationEnum.BottomLeft:
      res = {
        bottom: `${isListing ? 14.3 : 2}rem`,
        left: `${isListing ? 0.5 : 11}rem`,
      }
      positionCounter[location]++
      break
    case LabelDTOLocationEnum.BottomRight:
      res = {
        bottom: `${isListing ? 14.3 : 2}rem`,
        right: `${shift}rem`,
      }
      positionCounter[location]++
      break
    case LabelDTOLocationEnum.TopLeft:
      res = {
        top: '.2rem',
        left: `${isListing && isInAction ? shift : shift * 3.8}rem`,
      }
      positionCounter[location]++
      break
    case LabelDTOLocationEnum.TopRight:
      res = {
        top: '.5rem',
        right: `${isListing ? '4.3' : '6.5'}rem`,
      }
      positionCounter[location]++
      break
    default:
      res += ''
      break
  }
  return res
}

const getAppearance = (el: RawLabelType) => {
  let appearance = {}
  appearance = {
    width: '3.5rem',
    height: '3.5rem',
  }
  if (el.icon) {
    appearance['color'] = el.color
    appearance['background'] = el.backgroundColor

    if (el.shape === 'circle') {
      appearance['border-radius'] = '50%'
    }
  }

  return appearance
}
